export default function PHP_MySQLDatabase() {
  return (
    <div>
      <h1>PHP_MySQLDatabase</h1>
    </div>
  );
}
